import { Link } from "react-router-dom";
import { BookOpen, Heart } from "lucide-react";
import { API } from "@/lib/api";
import StarRating from "@/components/StarRating";

export default function WorkCard({ work, onDonate, index = 0 }) {
  const price = (work.price_cents / 100).toFixed(2);
  const excerptShort = work.excerpt.length > 220 ? work.excerpt.slice(0, 220) + "…" : work.excerpt;
  const coverUrl = work.cover_path ? `${API}/files/${work.cover_path}` : null;

  return (
    <article
      className="gold-frame paper-scroll rounded-sm p-6 sm:p-7 flex flex-col h-full"
      style={{ animationDelay: `${index * 60}ms` }}
      data-testid={`work-card-${work.id}`}
    >
      {coverUrl && (
        <Link to={`/work/${work.id}`} className="block mb-5 -mx-6 sm:-mx-7 -mt-6 sm:-mt-7">
          <div className="h-48 overflow-hidden border-b border-[rgba(217,180,114,0.15)]">
            <img src={coverUrl} alt={work.title} className="w-full h-full object-cover" data-testid={`work-cover-${work.id}`} onError={(e) => { e.currentTarget.parentElement.parentElement.style.display = "none"; }} />
          </div>
        </Link>
      )}

      <div className="flex items-center justify-between mb-4">
        <span className="chip" data-testid="work-genre">{work.genre}</span>
        <span className="font-mono-brass text-xs text-[#6E675E] uppercase tracking-widest">{work.work_type.replace("_", " ")}</span>
      </div>

      <Link to={`/work/${work.id}`} className="group" data-testid={`work-title-link-${work.id}`}>
        <h3 className="font-serif-display text-2xl sm:text-3xl leading-tight text-[#F7F3EC] group-hover:text-[#E6B860] transition-colors duration-200 mb-3">
          {work.title}
        </h3>
      </Link>

      <p className="font-serif-body text-sm leading-relaxed text-[#A8A095] mb-4 flex-1">
        {excerptShort}
      </p>

      <div className="flex items-center gap-4 mb-5 pt-4 border-t border-[rgba(217,180,114,0.1)]">
        <div className="flex-1">
          <div className="text-[10px] uppercase tracking-widest text-[#6E675E] font-mono-brass mb-1">Pseudonym</div>
          <Link to={`/author/${encodeURIComponent(work.author_pseudonym)}`} className="text-sm text-[#D9B472] font-serif-display italic hover:text-[#E6B860] transition-colors duration-200" data-testid={`work-author-link-${work.id}`}>
            {work.author_pseudonym}
          </Link>
        </div>
        <div className="text-right">
          <div className="text-[10px] uppercase tracking-widest text-[#6E675E] font-mono-brass mb-1">Draft</div>
          <div className="text-sm text-[#F7F3EC] font-mono-brass">{work.completion_percent}%</div>
        </div>
      </div>

      {work.rating_count > 0 && (
        <div className="mb-4"><StarRating avg={work.avg_rating || 0} count={work.rating_count || 0} /></div>
      )}

      <div className="flex items-stretch gap-2">
        <Link
          to={`/work/${work.id}`}
          className="btn-buy flex-1 rounded-sm py-3 text-center font-mono-brass text-xs uppercase tracking-widest font-semibold flex items-center justify-center gap-2"
          data-testid={`buy-work-button-${work.id}`}
        >
          <BookOpen className="w-3.5 h-3.5" />
          Unlock · ${price}
        </Link>
        <button
          onClick={() => onDonate(work)}
          className="btn-donate rounded-sm px-4 py-3 font-mono-brass text-xs uppercase tracking-widest flex items-center justify-center gap-1.5"
          data-testid={`donate-button-${work.id}`}
        >
          <Heart className="w-3.5 h-3.5" />
          Tip
        </button>
      </div>
    </article>
  );
}
